export default function Footer() {
  const footerLinks = {
    快速导航: [
      { to: '/', label: '首页' },
      { to: '/categories', label: '分类浏览' },
      { to: '/about', label: '关于我们' },
    ],
    热门分类: [
      { to: '/categories?cat=gushi', label: '真实故事' },
      { to: '/categories?cat=shenghuo', label: '生活资讯' },
      { to: '/categories?cat=jiankang', label: '健康专栏' },
      { to: '/categories?cat=quanyi', label: '权益支持' },
    ],
    支持资源: [
      { to: '/categories?cat=quanyi', label: '法律援助' },
      { to: '/categories?cat=jiankang', label: '心理健康' },
      { to: '/about', label: '联系我们' },
    ],
  };

  return (
    <footer className="bg-secondary-100/50 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-rainbow-line text-lg text-white"></i>
              </div>
              <span className="text-lg font-semibold font-heading text-foreground-900">男同网</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              专为男同群体打造的综合性平台，提供交友、社群互动、生活资讯与权益支持服务。安全、包容、多元的社区氛围。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 text-foreground-500 hover:text-primary-500 hover:bg-primary-100/50 transition-colors cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 男同网 nantongwang.com - 保留所有权利
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">使用条款</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer">社区规范</a>
          </div>
        </div>
      </div>
    </footer>
  );
}